<template>
    <button class="btn btn-primary" @click="$emit('click')" :disabled="disabled">
      Send
    </button>
</template>
  
<script>
    export default {
        name: 'SendButton',
        props:  {
            disabled: {
                type: Boolean,
                required: true
            }
        },
    }
</script>

<style scoped>
    button.btn.btn-primary {
        width: 20rem;
        padding: 1rem 2rem;
        border-radius: 10px;
        font-size: 1.6rem;
    }
</style>